<template>
  <div>
    <!-- 右中标题开始-->
    <div
      id="itemd00a0940-3e05-11ec-a2e6-953464dcce14"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
        lineHeight: '1.5',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
      }"
      class="centertitle"
    >
      <p>岗位占比</p>
    </div>
    <!-- 右中标题结束-->

    <!-- 右中echarts开始-->
    <div id="item40b1de80-3e05-11ec-a2e6-953464dcce14"></div>
    <!-- 右中echarts结束-->

    <!-- 右中背景图开始-->
    <div id="item677df680-3deb-11ec-a2e6-953464dcce14">
      <img src="../../../assets/images/线框.png" alt="" :style="{ width: '100%', height: '100%' }" />
    </div>
    <!-- 右中背景图结束-->
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {baseURL} from '@/api/base.js';
import axios from 'axios'
export default {
  mounted () {
    this.setEcharts()
  },
  data () {
    return {
      resData: []
    }
  },
  methods: {
  setEcharts() {
    const xData = [];
    const showEchartsData = [{
      name: '签约项目数量',
      type: 'bar',
      barMaxWidth: 30,
      data: []
    }];
    // 初始化图表
    const chartDom = document.getElementById('item40b1de80-3e05-11ec-a2e6-953464dcce14');
    const myChart = echarts.init(chartDom);

    // 定义基础配置
    const option = {
      grid: { right: '20%', bottom: 80 },
      xAxis: [{
        type: 'category',
        data: xData,
        axisPointer: { type: 'shadow' },
        axisLabel: { interval: 0, rotate: '-20' }
      }],
      yAxis: [{ 
        type: 'value',
        name: '签约项目数量',
        splitLine: { show: true, lineStyle: { color: '#375C77' } }
      }],
      series: showEchartsData
    };

    // 首次渲染空图表
    myChart.setOption(option);

    // 获取数据
    axios.get(baseURL+'/api/getright2').then(response => {
      this.resData = response.data.statistic;
      const rawData = JSON.parse(JSON.stringify(this.resData));

      // 填充新数据
      Object.keys(rawData).forEach(key => {
        if (key !== '__ob__') {
          xData.push(key);
          showEchartsData[0].data.push(rawData[key])
        }
      });

      // 更新图表
      myChart.setOption(option);
    });
  }
}

}
</script>

<style scoped>
/* 背景位置及大小 */
#item677df680-3deb-11ec-a2e6-953464dcce14 {
  top: 320px;
  left: 20px;
  width: 530px;
  height: 310px;
}
/* 标题位置 */
#itemd00a0940-3e05-11ec-a2e6-953464dcce14 {
  top: 334px;
}
#item40b1de80-3e05-11ec-a2e6-953464dcce14 {
  top: 370px;
  width: 520px;
  height: 260px;
}
</style>
